/**
 * Firestore write promises resolve only when the server acks. The write is already in the
 * persistent local queue (IndexedDB) the moment it's issued and syncs on reconnect, so
 * offline — or on a dead connection that still reports online — don't block the UI on it.
 * Online rejections (e.g. rules) inside the grace window still reach the caller.
 */
export function syncWrite(write: Promise<unknown>, graceMs = 4000): Promise<void> {
  write.catch((err) => console.error('[sync] write rejected', err));
  if (!navigator.onLine) return Promise.resolve();
  return Promise.race([
    write.then(() => undefined),
    new Promise<void>((resolve) => setTimeout(resolve, graceMs)),
  ]);
}
